// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3hEcA","buttons":"RemoveExpirationActionButtons_buttons__3dIEd"};